export const NameAndIdentifierTypeList = [
  "CUI Asset",
  "SPA - People",
  "SPA - Technology",
  "SPA - Facility",
  "Contractor Risk Managed Asset (CRMA)",
  "Specialized Asset (SA)",
  "Out of Scope Asset (OSA)",
];
